<div class="contact-modal" *ngIf="isVisible">
  <div class="contact-modal__content">
    <button class="contact-modal__close" (click)="onClose()">×</button>

    <img src="../../../../assets/icons/contact.svg" alt="Support Icon" class="contact-modal__icon" />

    <h2 class="contact-modal__title">How can we help?</h2>
    <p class="contact-modal__desc">We’re here to support you every step of the way!</p>

    <p class="contact-modal__desc">
      Have a question? Submit a ticket on our website or send us an email - we’re always glad to help.
    </p>

    <div class="contact-modal__info" role="contentinfo" aria-label="Contact Information">
      <div class="contact-modal__email">
        <img src="../../../../assets/icons/email.svg" alt="Email Icon" />
        <a [href]="'mailto:' + supportEmail" [attr.aria-label]="'Email support ' + supportEmail">{{ supportEmail }}</a>
      </div>
      <div class="contact-modal__phone">
        <img src="../../../../assets/icons/phone.svg" alt="Phone Icon" />
        <a [href]="'tel:' + supportPhoneTel" [attr.aria-label]="'Phone number ' + supportPhone">{{ supportPhone }}</a>
      </div>
    </div>

    <app-button variant="main" size="md" (click)="submitTicket()"> CONTACT US </app-button>
  </div>
</div>
